import { createStyles } from "@mantine/core";
import { CSSProperties } from "@mantine/styles/lib/tss/types/css-object";
import { colors, pxToRem } from "theme";

import { PhotoGridProps } from "./PhotoGrid";

type CreateStylesProp = {
  gridGap?: PhotoGridProps["gridGap"];
  imageFit?: CSSProperties["objectFit"];
};

export const useStyles = createStyles((_theme, { gridGap = pxToRem[12], imageFit = "cover" }: CreateStylesProp) => ({
  caption: {
    height: "100%",
    wordBreak: "break-word",
  },
  photoGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: gridGap,
    width: "100%",
    position: "relative",
  },
  photoGridCell: {
    flex: "1",
    borderRadius: "5px",
  },
  image: {
    maxHeight: "100%",
    objectFit: imageFit,
    width: "100%",
    height: "100%",
    borderRadius: "5px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 0,
  },
  imageContainer: {
    maxHeight: "50vw",
    minHeight: "154px",
    minWidth: "154px",
    width: "100%",
    borderRadius: "5px",
    position: "relative",
    paddingTop: "100%",
    justifySelf: "flex-end",
    overflow: "hidden",
    flex: "1",
    "&:nth-of-type(2n)": {
      justifySelf: "flex-start",
    },
  },
  deleteImageIcon: {
    borderRadius: "50%",
    padding: "7px",
    height: pxToRem[32],
    width: pxToRem[32],
    backgroundColor: colors.red[5],
    position: "absolute",
    top: pxToRem[12],
    right: pxToRem[12],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  },
}));
